import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { getArrayWithNonEmptyValues } from '@frontend/payments-hooks';

export const useGetProviders = (locationId: string | undefined | string[]) => {
  const locationIds = getArrayWithNonEmptyValues(locationId);
  const providersResult = SchedulerV3.Helpers.useGetProvidersV3Data({
    selectedLocationId: locationIds[0] || '',
    selectedLocationIds: locationIds,
    bypassScheduleV3FlagCheck: true,
  });

  return {
    providers: providersResult.data?.providers || [],
    isLoading: providersResult.isLoading,
    isFetched: providersResult.isFetched,
    error: providersResult.error,
  };
};
